<template>
  <div class="w-full">
    <label v-if="label" class="text-[#003F82] text-[16px] leading-[140%] font-bold" :for="`dd-selector${label}`">
      {{ label }}
    </label>
    <select
      class="appearance-none bg-white text-[16px] text-[#003F82] font-bold leading-[140%] w-full flex justify-between items-center px-[16px] py-[12px] border-[1px] border-solid border-[#3C80DF] rounded-[6px] mt-[8px] bg-[url('!!url-loader!@stylesheets/assets/chevron_down.svg')] bg-no-repeat bg-[center_right_16px]"
      v-model="selectedOption"
      :id="`dd-selector${label}`"
    >
      <option v-for="(option, idx) in options" :key="idx" :value="option.id">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";

const props = defineProps<{
  label?: string;
  options: Array<{ id: string; text: string }>;
  default?: string;
}>();

const emit = defineEmits(["option-selected"]);

const selectedOption = ref(findDefaultOrFirst());

function findDefaultOrFirst(): string {
  let selected = undefined;
  if (props.default) {
    selected = props.options.find((o) => o.id === props.default)?.id;
  }

  return selected ? selected : props.options[0].id;
}

watch(selectedOption, (newValue: string) => {
  emit("option-selected", { selected: newValue });
});

watch(
  () => props.options,
  () => {
    selectedOption.value = findDefaultOrFirst();
  },
  { deep: true }
);

onMounted(() => {
  emit("option-selected", { selected: selectedOption.value });
});
</script>

<style scoped>
@tailwind utilities;
</style>
